import clsx from 'clsx';
import { v4 } from 'uuid';

export default function TextField({
    'aria-label': ariaLabel,
    className,
    'data-testid': dataTestId,
    info: InfoComponent,
    inputClass,
    label,
    name,
    placeholder,
    rows,
    type,
    value,
    onBlur,
    onChange,
}: TextFieldProps) {
    
    const containerClasses = clsx("d-flex flex-column-reverse field-group", className);
    const inputClasses = clsx("field-input", inputClass, type);

    const id = `${v4()}-${name}`;

    const props = {
        'aria-label': ariaLabel,
        className: inputClasses,
        'data-testid': dataTestId,
        id,
        name,
        placeholder,
        value,
        onBlur: (e: any) => onBlur?.(e.currentTarget.value, name),
        onChange: (e: any) => onChange?.(e.currentTarget.value, name),
    };

    return (
        <div className={containerClasses}>
            <div className="field-control">
                {rows ? <textarea rows={rows} {...props} /> : <input type={type || "text"} {...props} />}
            </div>
            {label && (
                <div>
                    <label className="field-label" htmlFor={id}>
                        {label}
                    </label>
                    {InfoComponent && <InfoComponent />}
                </div>
            )}
        </div>
    );
}
